import React, { PureComponent } from 'react';
import { EditWrapper } from 'appSrc/components/Shards';
import { DLRichTextEditor } from 'appSrc/components/UI';


class EditableTextToggle extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            copyText: props.copy,
        };
        this.hasUpdated = false;
    }
    updateCopyText = ( value ) => {
        this.hasUpdated = true;
        this.setState( { copyText: value } );
    }
    onSave = () => {
        let update = this.hasUpdated ? this.state.copyText : this.props.copy;
        this.props.onSave( update );
    }


    render() {
        const { copy, canEdit } = this.props;

        return (
            <EditWrapper canEdit={ canEdit } className={ this.props.className }
            viewChild={ (
                <div className='ql-output' dangerouslySetInnerHTML={ { __html: copy } }></div>
            ) }
            editChild={ (
                <DLRichTextEditor value={ copy }
                onChange={ this.updateCopyText } />
            ) }
            onSave={ this.onSave } />
        );
    }
}
EditableTextToggle.defaultProps = {
    copy: '',
    swapView: ()=>{},
    className: '',
    onSave: () => {},
};

export default EditableTextToggle;
